import { Injectable } from '@angular/core';
import { Setting } from '../../models/UIModels/Setting';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {

  public InvoiceSetings:Array<Setting>;
  public ArchiveSetings:Array<Setting>;
  public DespatchSetings:Array<Setting>;
  public SmmSetings:Array<Setting>;
  public MmSetings:Array<Setting>;


  constructor() { 
    this.InvoiceSetings = new Array<Setting>();
    this.ArchiveSetings = new Array<Setting>();
    this.DespatchSetings = new Array<Setting>();
    this.SmmSetings = new Array<Setting>();
    this.MmSetings = new Array<Setting>();
  }
}
